module.exports = __webpack_public_path__ + "static/media/getItOnGooglePlay@3x.80e704cc.png";